import React, { useState, useEffect, useContext } from 'react'
import { dataBaseColumns } from './dataBaseColumns'
import { InputDiv, StyledSelect, StyledOption } from './style'
import ImportFromExcelContext from '../../../../../contexts/ImportFromExcelContext'

interface DataBaseColumnsSelectsProps {
  numberOfSelects: number
}

const DataBaseColumnsSelects: React.FC<DataBaseColumnsSelectsProps> = ({
  numberOfSelects,
}) => {
  const { translationMapping, setTranslationMapping } = useContext(
    ImportFromExcelContext,
  )
  const [selectedValues, setSelectedValues] = useState<string[]>(
    Array(numberOfSelects).fill(''),
  )

  useEffect(() => {
    // Atualizar as seleções iniciais com base no translationMapping
    const initialSelectedValues = Object.values(translationMapping).slice(
      0,
      numberOfSelects,
    ) as string[]
    setSelectedValues(initialSelectedValues)
  }, [translationMapping, numberOfSelects])

  const handleSelectChange = (
    index: number,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newSelectedValues = [...selectedValues]
    newSelectedValues[index] = e.target.value
    setSelectedValues(newSelectedValues)

    const updatedTranslationMapping = { ...translationMapping }
    // Atualizar o translationMapping com os valores selecionados
    updatedTranslationMapping[Object.keys(translationMapping)[index]] =
      e.target.value
    setTranslationMapping(updatedTranslationMapping)
  }

  const renderDataBaseColumnsSelects = () => {
    const columnSelects = []

    for (let i = 0; i < numberOfSelects; i++) {
      const selectOptions = dataBaseColumns.map((option, index) => (
        <StyledOption key={index} value={option.value}>
          {option.label}
        </StyledOption>
      ))

      columnSelects.push(
        <InputDiv key={i}>
          <StyledSelect
            key={selectedValues[i]}
            value={selectedValues[i]}
            onChange={(e) => handleSelectChange(i, e)}
          >
            <StyledOption selected value=''>
              Selecione
            </StyledOption>
            {selectOptions}
          </StyledSelect>
        </InputDiv>,
      )
    }

    return columnSelects
  }

  return <>{renderDataBaseColumnsSelects()}</>
}

export default DataBaseColumnsSelects
